<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name" id="benefitHeader">{{pageTitle}}</div>
                <!--<button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>-->
            </div>
            <div class="admin-page-content">
                <form id="faq">
                    <div class="forms-container">
                        <div class="row no-margin">
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="payroll">Payroll Email :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="payroll" type="text" class="form-control" id="payroll" placeholder="Enter Payroll Email" />
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{payrollError}}</font>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="hr_email">HR Email :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="hr_email" type="text" class="form-control" id="hr_email" placeholder="Enter HR Email" />
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{hr_emailError}}</font>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="hr_admin_number">HR Admin Contact :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="hr_admin_number" type="text" class="form-control" id="hr_admin_number" placeholder="Enter HR Admin Contact" />
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{hr_admin_numberError}}</font>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="employee_hotline">Employee Hotline :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="employee_hotline" type="text" class="form-control" id="employee_hotline" placeholder="Enter Employee Hotline Number" />
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{employee_hotlineError}}</font>
                                </div>
                            </div>
                            <div class="col-12 forms-block">
                                <div class="col-1 paddingleft0">
                                    <button type="button" v-on:click="addNewLink" class="btn btn-block btn-success">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                </div>
                                <div class="mt-2 col-11 paddingleft0">
                                    Would you like to add more Social Links?
                                </div>
                            </div>
                            <div class="row col-12" v-for="(socialMediaLink, index) in socialMediaLinks">
                                <div class="col-12 forms-block">
                                    <div class="col-1 paddingleft0">
                                        <button type="button" v-on:click="removeSocialLink(index)" class="btn btn-block btn-danger">
                                            <i class="fa fa-times" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                    <div class="col-11 paddingleft0">
                                        <div class="col-6 paddingleft0">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label" >Social Media :</div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <v-select 
                                                    v-model="socialMediaLink.social_title"
                                                    name="socialMediaLinks[][social_title]"
                                                    placeholder= "Select Social Media" 
                                                    :id="'socialMediaLinks_'+ index"
                                                    label="text"
                                                    :clearable="false"
                                                    :searchable="false"
                                                    :filterable="false"
                                                    :options="socialOptions"></v-select>
                                            </div>
                                        </div>
                                        <div class="col-6 paddingleft0">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label" >Social Media Link :</div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <input v-model="socialMediaLink.social_value" type="text"
                                                       name="socialMediaLinks[][social_value]" class="form-control" placeholder="Enter Social Media Link">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="hr_email">Last Updated By :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <span  class="form-control"  >{{lastUpdatedBy}}</span>
                                </div>
                            </div>
                            <!--Error Alert-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <div class="alert alert-danger" id="alertError">
                                        <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>
                            </div>

                            <!--Buttons-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <input id="addBenifitBtn" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="updateContactHR()">
                                    <input id="CancelBenifit" type="submit" value="Refresh" class="btn btn-primary" v-on:click.prevent="loadHRContact">
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--page content-->
                </form>
            </div>
            <!--End Add Section-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    var self;
    import vSelect from 'vue-select';
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import SessioMixin from '../../../mixins/sessionmixin';
    import {HTTP} from '../../../http-common';

    export default {
        name: 'Login',
        props: [''],
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                pageTitle: 'Update Contact HR',
                socialOptions: [
                    {text: 'Facebook', value: 'facebook'},
                    /*{text: 'Google+', value: 'googleplus'},*/
                    {text: 'Instagram', value: 'instagram'},
                    {text: 'LinkedIn', value: 'linkedin'},
                            /*{text: 'Pinterest', value: 'pinterest'},
                             {text: 'Twitter', value: 'twitter'},
                             {text: 'YouTube', value: 'youtube'}*/
                ],
                socialMediaLink: {
                    social_title: '',
                    social_value: '',
                },
                socialMediaLinks: [{
                        social_title: '',
                        social_value: '',
                    }
                ],
//              V-model
                lastUpdatedBy: '',
                payroll: '',
                hr_email: '',
                hr_admin_number: '',
                employee_hotline: '',

//              FrontEnd Errors
                payrollError: '',
                hr_emailError: '',
                hr_admin_numberError: '',
                employee_hotlineError: '',

//              BackEnd Error
                backendErrors: [],
            }
        },
        mounted: function () {
            self = this;
            self.checkLogin();

            var path = window.location.pathname;
            var segments = path.split("/");

            self.loadHRContact();

            $("#payroll").on('keyup', function () {
                self.payrollError = '';
            });
            $("#hr_email").on('keyup', function () {
                self.hr_emailError = '';
            });
            $("#hr_admin_number").on('keyup', function () {
                self.hr_admin_numberError = '';
            });
            $("#employee_hotline").on('keyup', function () {
                self.employee_hotlineError = '';
            });

            $("#alertError").hide();
            $('#main-header').hide();
            $('#main-footer').hide();
            $('html,body,#app').css({
                //height: "100%"
            });

            $("#login-main-hr").height($(window).height());

        },
        watch: {

        },
        methods: {
            buttonBack() {
                $(".back_button").prop("disabled", false);
                self.$router.push('/backend/draggablefaqlist');
            },
            addNewLink: function () {
                self.socialMediaLinks.push(Vue.util.extend({}, self.socialMediaLink))
            },
            removeSocialLink: function (index) {
                Vue.delete(self.socialMediaLinks, index);
            },
            checkForm: function () {
                var checked = true;

                if (!self.payroll) {
                    self.payrollError = "Payroll Email Required";
                    if (checked) {
                        checked = false;
                    }
                } else if (!self.validEmail(self.payroll)) {
                    self.payrollError = 'Please Enter Valid Email';
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.hr_email) {
                    self.hr_emailError = "Payroll Email Required";
                    if (checked) {
                        checked = false;
                    }
                } else if (!self.validEmail(self.hr_email)) {
                    self.hr_emailError = 'Please Enter Valid Email';
                    if (checked) {
                        checked = false;
                    }
                }


                if (!self.hr_admin_number) {
                    self.hr_admin_numberError = "HR Admin Contact Required";
                    if (checked) {
                        checked = false;
                    }
                } else if (!String(self.hr_admin_number).match(/^[0-9]*$/)) {
                    self.hr_admin_numberError = "HR Admin Contact Must Be Numeric";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.employee_hotline) {
                    self.employee_hotlineError = "Employee Hotline Number Required";
                    if (checked) {
                        checked = false;
                    }
                } else if (!String(self.employee_hotline).match(/^[0-9]*$/)) {
                    self.employee_hotlineError = "Employee Hotline Number Must Be Numeric";
                    if (checked) {
                        checked = false;
                    }
                }

                return checked;
            },
            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

            loadHRContact() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    /*params: {
                     'type': self.categoryType,
                     }*/
                };
                self.showLoader();
                HTTP.get("getcontacthr", config)
                        .then(function (response) {
                            self.lastUpdatedBy = response.data.content.updated_by;
                            self.payroll = response.data.content.payroll_email;
                            self.hr_email = response.data.content.hr_email;
                            self.hr_admin_number = response.data.content.hr_admin_contact;
                            self.employee_hotline = response.data.content.employee_hotline;
                            if (response.data.content.social_links.length) {
                                self.socialMediaLinks = response.data.content.social_links;
                            } else {
                                self.socialMediaLinks = [{
                                        social_title: '',
                                        social_value: '',
                                    }
                                ];
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },

            updateContactHR(flag) {
                /*console.log(JSON.stringify(self.socialMediaLinks));*/
                if (self.checkForm()) {
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    var data = {
                        payroll: self.payroll,
                        hr_email: self.hr_email,
                        hr_admin_number: self.hr_admin_number,
                        employee_hotline: self.employee_hotline,
                        social_media_links: self.socialMediaLinks,
                    };
                    this.$swal({
                        title: 'Are you sure?',
                        text: 'You can\'t revert your action',
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Yes Update it!',
                        cancelButtonText: 'No, Keep it!',
                        showCloseButton: true,
                        showLoaderOnConfirm: true
                    }).then((result) => {
                        if (result.value) {
                            self.showLoader();
                            HTTP.post("updatecontacthr", data, config)
                                    .then(function (response) {
                                        if (response.data.status == "success") {
                                            // self.$router.push('/task/list');
                                            $("#errorMsg").html(response.data.content);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            self.loadHRContact();
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 3000);
                                        } else {
                                            $("#alertError").show();
                                            if (response.data.content.length > 0) {
                                                var err = "";
                                                for (var i = 0; i < response.data.content.length; i++) {
                                                    err += response.data.content[i] + "<br>";
                                                }
                                                $("#errorMsg").html(err);
                                                $(".alert-danger").removeClass("hide");
                                                $(".alert-danger").addClass("show");
                                            }
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }
                                        self.hideLoader();
                                    })
                                    .catch(function (err) {
                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }
                                        self.hideLoader();
                                    });
                        } else {
                            self.loadHRContact();
                            self.$swal('Cancelled', 'Your record(s) still intact', 'info');
                        }
                    });

                }

                //
            },

        }
    }
</script>

<style>
    .disabled {
        pointer-events:none;
        color: #bfcbd9;
        cursor: not-allowed;
        background-image: none;
        background-color: #eef1f6;
        border-color: #d1dbe5;
    }
</style>



// WEBPACK FOOTER //
// src/components/backend/contactHR/UpdateContactHR.vue